import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon, BookOpenIcon, DumbbellIcon, ZapIcon, ClipboardListIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const pillars = [{
  icon: BookOpenIcon,
  tag: 'Incluido 📚',
  title: 'Los 6 Tomos del Sistema "Sesión en Mano"',
  value: '59,90€',
  today: 'Hoy: Incluido en el Kit',
  lead: 'Tu año completo ya planificado — abres, lees y entrenas.',
  items: ['Fundamentos de Oro (6-9 años): El primer contacto con el baloncesto hecho bien.', 'El Motor Técnico (10-12 años): Bote, pase, tiro y defensa construidos con progresión.', 'La Transición Táctica (13-14 años): Contraataque, espaciado, zonas y sistemas colectivos.', 'Construcción Competitiva (15-18 años): Sistemas avanzados, bloqueos y final de partido.', 'Especialidades: Preparación física, tiro avanzado y scouting del rival.', 'Gestión de Equipos: Vestuario, familias, psicología y cierre de temporada.']
}, {
  icon: DumbbellIcon,
  tag: 'Incluido 💪',
  title: 'Los 5 Bonos de Implementación Rápida',
  value: '59,50€',
  today: 'Hoy: Incluido en el Kit',
  lead: 'Los recursos que hacen que el manual funcione desde el primer día.',
  items: ['Plan de Arranque en 7 Días: Por dónde empezar sin agobiarte.', '25 Calentamientos Inteligentes: Con balón y conectados al objetivo de la sesión.', 'Biblioteca de Juego Reducido: 30 situaciones (1v1, 2v2, 3v3) para enseñar a decidir.', 'Ruedas de Finalización Pro: 24 ejercicios de tiro por tipo de jugador y nivel.', 'Sistema Express: 20 sesiones para días de media pista, pocos jugadores o poco tiempo.']
}, {
  icon: ZapIcon,
  tag: 'Incluido 💥',
  title: 'KIT DE IMPLEMENTACIÓN TOTAL',
  value: '19,90€',
  today: 'Disponible en el Pack Premium',
  lead: 'La herramienta definitiva para llevar el manual a la pista sin esfuerzo.',
  items: ['Cronograma Maestro Anual: Septiembre a Junio. Qué sesión toca cada día.', 'Versión Pocket para Móvil: 80+ fichas de consulta rápida optimizadas para el pabellón.', 'Índice de Búsqueda Rápida: Encuentra cualquier ejercicio en 2 clics.']
}, {
  icon: ClipboardListIcon,
  tag: 'Incluido 📊',
  title: 'Seguimiento y Evaluación del Jugador',
  value: 'incluido',
  today: 'Hoy: Gratis con el Kit',
  lead: 'Mide el progreso real de cada jugador con herramientas concretas.',
  items: ['Fichas de diagnóstico técnico inicial.', 'Señales de éxito por sesión y por período.', 'Evaluación de los 5 fundamentos clave al cierre de cada período.']
}];
export function WhatYouGet() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-343" data-mp="2q8wiyw4enacr">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-344" data-mp="zvfi1h195uzv">
        <SectionTag icon="🎁" data-id="element-345" data-mp="zvxjqt6op1f6">Lo que recibes hoy (Todo incluido)</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-346" data-mp="vuvlaeklcte9">
          Todo lo que necesitas, en un solo lugar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-347" data-mp="ps0eswkft8fw">
          Cuatro pilares de contenido técnico para eliminar el estrés semanal y elevar la calidad de cada
          entrenamiento que das.
        </p>
        <p className="mt-2 text-sm font-medium text-orange" data-id="element-348" data-mp="gxvtstrzir8a">
          Más de 180 sesiones · 6 Tomos · +10 Meses de entrenamientos · 100% Editable
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-6 px-4 sm:px-6 lg:grid-cols-2" data-id="element-349" data-mp="71ipz32q6wzt">
        {pillars.map((pillar, i) => <m.div key={pillar.title} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: i % 2 * 0.1
      }} className="flex flex-col rounded-2xl border border-white/10 bg-bg-secondary p-6 sm:p-7" data-id="element-350" data-mp="3p7xe1uupknbx" data-mpi={i}>
            <div className="flex items-start justify-between gap-3" data-id="element-351" data-mp="3ohgoz5hadzpc">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-orange/10" data-id="element-352" data-mp="3ogp4app89mdu">
                <pillar.icon size={22} className="text-orange" data-id="element-353" data-mp="3jgkpd43ywzpq" />
              </div>
              <span className="rounded-full bg-white/5 px-3 py-1 text-xs font-semibold text-muted" data-id="element-354" data-mp="3ehhlhmzq4zjc">
                {pillar.tag}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-semibold leading-snug text-white sm:text-xl" data-id="element-355" data-mp="35jny51jxtg8b">
              {pillar.title}
            </h3>
            <div className="mt-2 flex items-baseline gap-2 text-sm" data-id="element-356" data-mp="30q2xt2uvga5y">
              <span className="text-muted line-through" data-id="element-357" data-mp="2vtcn6v1u66rx">Valor: {pillar.value}</span>
              <span className="font-semibold text-success" data-id="element-358" data-mp="2qv19284ida3w">{pillar.today}</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-359" data-mp="2mqtj67mbdo43">{pillar.lead}</p>
            <ul className="mt-4 space-y-2.5" data-id="element-360" data-mp="2hss19q0mjuu7">
              {pillar.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-white/90" data-id="element-361" data-mp="xbslhw4nxaj3">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-362" data-mp="129aufmiojpr3" />
                  <span data-id="element-363" data-mp="16b5zn23qena5">{item}</span>
                </li>)}
            </ul>
          </m.div>)}
      </div>
    </section>;
}